import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE, PROJECT } from '../../constants/general.constants';
import {
  OAuthCredential,
  OAuthInitiateRequest,
  OAuthInitiateResponse,
  OAuthProviderConfig
} from '../../interfaces';

@Injectable({
  providedIn: 'root'
})
export class OAuthStorageService {
  readonly #httpClient = inject(HttpClient);

  /**
   * List OAuth provider configs available for a given integration (storage provider).
   * GET /api/oauth/providers?integrationId={integrationId}
   * integrationId is a numeric i32 on the server.
   */
  getProviders(integrationId?: number): Observable<OAuthProviderConfig[]> {
    const url = `${API_BASE}/oauth/providers`;
    const params: Record<string, string> = {};
    if (integrationId !== undefined) {
      params['integrationId'] = String(integrationId);
    }
    return this.#httpClient.get<OAuthProviderConfig[]>(url, { params });
  }

  /**
   * Initiate an OAuth authorization flow for the given provider config.
   * POST /api/oauth/initiate/{providerConfigId}
   * Body requires projectId and displayName.
   * Returns an authorization URL to open in a popup.
   */
  initiateOAuth(providerConfigId: number, request: OAuthInitiateRequest): Observable<OAuthInitiateResponse> {
    const url = `${API_BASE}/oauth/initiate/${providerConfigId}`;
    return this.#httpClient.post<OAuthInitiateResponse>(url, request);
  }

  /**
   * List the current user's stored OAuth credentials for this project.
   * GET /api/project/{id}/oauth-credentials
   */
  getCredentials(projectId: number): Observable<OAuthCredential[]> {
    const url = `${API_BASE}/${PROJECT}/${projectId}/oauth-credentials`;
    return this.#httpClient.get<OAuthCredential[]>(url);
  }
}
